import React from 'react';

interface JumpToRecipeProps {
    targetId?: string;
    className?: string;
    label?: string;
}

export const JumpToRecipe: React.FC<JumpToRecipeProps> = ({ 
    targetId = 'recipe-card', 
    className = "",
    label = "Jump to Recipe" 
}) => {
    const handleScroll = (e: React.MouseEvent) => {
        e.preventDefault();
        const element = document.getElementById(targetId);
        if (element) {
            const headerOffset = 100; // Account for sticky header
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    return (
        <button 
            onClick={handleScroll}
            className={`bg-brand-pink text-white px-6 py-2.5 rounded-full font-bold text-sm tracking-wide hover:bg-brand-pink-dark transition-all shadow-md hover:shadow-lg flex items-center gap-2 uppercase ${className}`}
        >
            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-4 w-4" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
            >
                <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={3} 
                    d="M19 14l-7 7m0 0l-7-7m7 7V3" 
                />
            </svg>
            {label}
        </button>
    );
};
